import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

interface Breadcrumb {
  label: string;
  link?: string;
}

interface NavigationPage { 
  title: string; 
  link: string; 
}

@Component({
  selector: 'app-assurance-cyber-risque',
  standalone: true,
  imports: [CommonModule, RouterModule, PageLayoutComponent],
  templateUrl: './assurance-cyber-risque.component.html',
  styleUrls: ['./assurance-cyber-risque.component.scss']
})
export class AssuranceCyberRisqueComponent {
  title = 'Assurance Risque Cybersécurité Informatique - Cyberattaque';
  subtitle = 'Protégez votre entreprise contre les cyberattaques et leurs conséquences';
  heroImage = 'assets/static_pages_images/cri.jpg';

  breadcrumbs: Breadcrumb[] = [
    { label: 'Entreprises', link: undefined },
    { label: 'Assurance Cyber-Risque', link: undefined }
  ];

  prevPage: NavigationPage = { 
    title: 'Assurance Multirisque Pro', 
    link: '/assurance-multirisque-pro'
  };

  nextPage: NavigationPage = { 
    title: 'Assurance RC Pro Générale', 
    link: '/assurance-rc-pro-generale'
  };
}
